import { IPreferredPartnerRadioButtonProps } from 'typings';
import { formatPartnerAddress } from 'utils/formatPartnerAddress';

import {
  Content,
  Input,
  Label,
  PartnerAddress,
  PartnerDistance,
  PartnerName,
} from './styles';

const getFormattedDistanceInMeters = (
  distanceUnit: string,
  distanceInMeters?: number | null,
) => {
  if (typeof distanceInMeters !== 'number') {
    return distanceInMeters;
  }

  const distance =
    distanceUnit === 'km'
      ? distanceInMeters * 0.001
      : distanceInMeters * 0.000621371;
  const distanceRounded = Math.floor(distance * 100) / 100;

  return `${distanceRounded}${distanceUnit}`;
};

export const PreferredPartnerRadioButton = ({
  className,
  partner: { address, distanceInMeters, name },
  ...inputProps
}: IPreferredPartnerRadioButtonProps) => {
  const distanceUnit =
    address.countryCode.toLowerCase().indexOf('us') === -1 ? 'km' : 'mi';
  const formattedDistance = getFormattedDistanceInMeters(
    distanceUnit,
    distanceInMeters,
  );

  return (
    <Label className={className}>
      <Input type="radio" {...inputProps}></Input>
      <Content>
        <PartnerName>{name}</PartnerName>
        {formattedDistance && (
          <PartnerDistance>{formattedDistance}</PartnerDistance>
        )}
        <PartnerAddress>
          {formatPartnerAddress(address).join(', ')}
        </PartnerAddress>
      </Content>
    </Label>
  );
};
